import { createContext, useContext, useState, useEffect } from "react";

const OracleContext = createContext();

export function OracleProvider({ children }) {
  const [isOracleActive, setIsOracleActive] = useState(() => {
    return localStorage.getItem("troquinho_oracle") === "true";
  });

  const toggleOracle = () => {
    setIsOracleActive((prev) => {
      const newValue = !prev;
      localStorage.setItem("troquinho_oracle", newValue);
      return newValue;
    });
  };

  return (
    <OracleContext.Provider value={{ isOracleActive, toggleOracle }}>
      {children}
    </OracleContext.Provider>
  );
}

export const useOracle = () => useContext(OracleContext);